<template>
<div>
  <div class="screen-message">
    <div class="message-item text-center">
      <h1>404
        <span>Page Not Found</span>
      </h1>
      <p>페이지를 찾을 수 없습니다.</p>
      <div class="back-button">
        <router-link :to="{name: 'top'}">메인으로</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {}
</script>
